<div class="modal-window__header">
  <div class="modal-window__title">{{ "location.movetool" | translate }}</div>
  <a (click)="modalService.close()">
    <i class="c-icon c-icon--close-dark"></i>
  </a>
</div>
<div class="modal-window__subtitle">{{ data.toolId }} - {{ data.modelNumber }}</div>
<form
  #f="ngForm"
  id="modal-form"
  (ngSubmit)="updateLocation(locationName.value)"
  class="o-grid--medium u-mt--medium">
  <div class="c-form-group o-grid__item col-12 col-sm-12">
    <label class="c-form-label">{{ "location.newlocation" | translate }}</label>
    <mat-select
      #locationName="ngModel"
      [ngModel]="data.locationName"
      name="location"
      id="location"
      class="c-user-menu__select c-select c-select--lg">
      <mat-option [value]="null">{{ "location.none" | translate }}</mat-option>
      <mat-option
        [value]="l.locationName"
        *ngFor="let l of locations">
        {{ l.locationName }}: {{ l.locationDescription }}
      </mat-option>
    </mat-select>
  </div>
  <div class="o-grid__item col-offset-6 col-3 u-mt--medium u-tablet">
    <button
      type="button"
      class="button--sm button-secondary button-block"
      (click)="modalService.close()">
      {{ "button.cancel" | translate }}
    </button>
  </div>
  <div class="o-grid__item col-12 col-md-3 u-mt--medium">
    <button
      type="submit"
      class="button--sm button-primary button-block"
      [disabled]="f.invalid || isLoading">
      <app-loading-icon *ngIf="isLoading"></app-loading-icon>
      <span *ngIf="!isLoading">{{ "button.save" | translate }}</span>
    </button>
  </div>
</form>
